import { render, staticRenderFns } from "./CreateMilestones.vue?vue&type=template&id=7bc0bc0b&"
import script from "./CreateMilestones.vue?vue&type=script&lang=js&"
export * from "./CreateMilestones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports